import type {
    FieldLegendColorsConstantType,
    FieldLegendColorsType
} from "./type";

export const FIELD_LEGEND_VARIANT: keyof NCoreUIKit.Typography = "titleSmallSize";

export const getFieldLegendColors = ({
    isDisabled,
    colors
}: FieldLegendColorsConstantType): FieldLegendColorsType => {
    return {
        color: isDisabled ? colors.content.text.disabled : colors.content.text.high
    };
};
